import React from "react";
import styles from "./AboutUs.module.scss";
import { whyChoose, missionStatement, offers } from "../../configration_data/configration";
import { Link, useNavigate } from "react-router-dom";
import ProtectedPaymentRoute from "../../auth/Auth";

export default function AboutUs() {
  ProtectedPaymentRoute();
  const navigate = useNavigate();

  return (
    <div className="font-sans antialiased bg-white text-[#202124]">
      
      {/* Hero Section */}
      <section 
        className="relative overflow-hidden pt-[140px] pb-20 lg:pt-[180px] lg:pb-28 border-b border-[#0f2c4f] flex items-center justify-center"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2560&auto=format&fit=crop')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        {/* Professional Deep Blue Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#021835] via-[#04244d]/90 to-[#04244d]/40 mix-blend-multiply"></div>
        <div className="absolute inset-0 bg-[#021835]/50"></div>

        <div className="container mx-auto px-4 lg:px-8 relative z-10 text-center flex flex-col items-center justify-center">
          <span className="text-[#8ab4f8] font-medium tracking-wider uppercase text-sm mb-3 block">
            Simplifying Business, Amplifying Success
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-[4.2rem] font-medium leading-[1.12] mb-6 tracking-tight text-white max-w-4xl">
            About Oktobiz
          </h1>
          <p className="text-lg md:text-[1.15rem] text-white/80 leading-[1.7] font-normal max-w-2xl mx-auto">
            Empowering entrepreneurs with expert-backed legal formation, tax advisory, and effortless compliance solutions.
          </p>
        </div>
      </section>

      {/* Who We Are Section */}
      <section className="py-20 lg:py-28 bg-white border-b border-[#f1f3f4]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
            
            {/* Left Image Collage (Curated High-Res Workplace Photos) */}
            <div className="lg:col-span-6 grid grid-cols-2 gap-4 sm:gap-6">
              <div className="space-y-4 sm:space-y-6">
                <div className="h-[220px] sm:h-[260px] rounded-[16px] overflow-hidden shadow-md border border-[#dadce0]">
                  <img
                    src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=800&auto=format&fit=crop"
                    alt="Team Collaboration"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="h-[160px] sm:h-[190px] rounded-[16px] overflow-hidden shadow-md border border-[#dadce0]">
                  <img
                    src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=800&auto=format&fit=crop"
                    alt="Corporate Meeting"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
              
              <div className="space-y-4 sm:space-y-6 pt-6 sm:pt-10">
                <div className="h-[160px] sm:h-[190px] rounded-[16px] overflow-hidden shadow-md border border-[#dadce0]">
                  <img
                    src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=800&auto=format&fit=crop"
                    alt="Business Advisory"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="h-[220px] sm:h-[260px] rounded-[16px] overflow-hidden shadow-md border border-[#dadce0]">
                  <img
                    src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?q=80&w=800&auto=format&fit=crop"
                    alt="Professional Support"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
            </div>

            {/* Right Text Content */}
            <div className="lg:col-span-6 flex flex-col justify-center">
              <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-sm mb-3 block">
                Our Heritage & Mission
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-[40px] font-medium text-[#202124] tracking-tight mb-6 leading-tight">
                Who We Are
              </h2>
              <p className="text-[17px] text-[#5f6368] leading-[1.8] mb-6">
                Founded by a team of experienced Accountants and legal experts, Oktobiz understands the challenges and opportunities that come with starting a business. We are passionate about helping you navigate these challenges with ease.
              </p>
              <p className="text-[17px] text-[#5f6368] leading-[1.8] mb-8">
                Our innovative digital solutions and personalized legal support are engineered to meet the unique needs of every entrepreneur, ensuring you have the tools, guidance, and peace of mind required for long-term growth.
              </p>

              {/* Quick Metrics */}
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 pt-6 border-t border-[#f1f3f4]">
                <div>
                  <h4 className="text-3xl font-bold text-[#1a73e8] tracking-tight mb-1">50+</h4>
                  <p className="text-[13px] text-[#5f6368] font-medium uppercase tracking-wider">States Supported</p>
                </div>
                <div>
                  <h4 className="text-3xl font-bold text-[#1a73e8] tracking-tight mb-1">100%</h4>
                  <p className="text-[13px] text-[#5f6368] font-medium uppercase tracking-wider">Compliance Rate</p>
                </div>
                <div>
                  <h4 className="text-3xl font-bold text-[#1a73e8] tracking-tight mb-1">24/7</h4>
                  <p className="text-[13px] text-[#5f6368] font-medium uppercase tracking-wider">Expert Guidance</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Vision & Values */}
      <section className="py-20 lg:py-24 bg-[#f8f9fa] border-b border-[#dadce0]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16 max-w-3xl mx-auto">
            <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-sm mb-3 block">Guiding Principles</span>
            <h2 className="text-3xl lg:text-[40px] font-medium text-[#202124] tracking-tight mb-4">Our Vision & Core Commitment</h2>
            <p className="text-[17px] text-[#5f6368] leading-relaxed">
              We strive to build a supportive ecosystem where business founders can turn their ambitious concepts into compliant, flourishing enterprises.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {missionStatement.map((ele) => (
              <div 
                key={ele.id} 
                className="bg-white rounded-[16px] p-8 lg:p-10 border border-[#dadce0] shadow-sm hover:shadow-md transition-shadow flex flex-col justify-between"
              >
                <div>
                  <div className="w-12 h-12 rounded-full bg-[#e8f0fe] flex items-center justify-center text-[#1a73e8] mb-6">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      {ele.type.includes("Vision") ? (
                        <circle cx="12" cy="12" r="10" />
                      ) : (
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      )}
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                  </div>
                  <h3 className="text-[24px] font-medium text-[#202124] mb-4 tracking-tight">
                    {ele.type}
                  </h3>
                  <p className="text-[15.5px] text-[#5f6368] leading-[1.8]">
                    {ele.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us (Dark Enterprise Parallax Section matching Homepage) */}
      <section className="py-20 lg:py-28 bg-[#202124] text-white relative overflow-hidden">
        {/* Abstract Ambient Glows */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgMGg0MHY0MEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik0yMCAxOXYyaC0xOXYtMmgxOXoiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4wNikiLz48cGF0aCBkPSJNMjEgMjB2MTloLTJ2LTE5aDJ6IiBmaWxsPSJyZ2JhKDI1NSwyNTUsMjU1LDAuMDYpIi8+PC9zdmc+')] opacity-100"></div>
          <div className="absolute top-[-10%] right-[-5%] w-[400px] lg:w-[600px] h-[400px] lg:h-[600px] rounded-full bg-[#4285F4] opacity-[0.08] blur-[100px]"></div>
          <div className="absolute bottom-[-10%] left-[-5%] w-[400px] lg:w-[500px] h-[400px] lg:h-[500px] rounded-full bg-[#34A853] opacity-[0.06] blur-[100px]"></div>
        </div>

        <div className="container mx-auto px-4 lg:px-8 relative z-10">
          <div className="text-center mb-16 max-w-3xl mx-auto">
            <span className="text-[#8ab4f8] text-[13px] font-semibold tracking-wider uppercase mb-3 block">Why Oktobiz</span>
            <h2 className="text-3xl md:text-4xl lg:text-[40px] font-normal mb-4 leading-tight">Why Choose Us?</h2>
            <p className="text-[17px] text-white/80 leading-relaxed">
              Everything you need to launch and operate your business with confidence, backed by certified professionals.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {whyChoose.map((ele) => (
              <div 
                key={ele.number} 
                className="bg-white/5 backdrop-blur-md rounded-[16px] p-8 border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all duration-300 flex flex-col justify-between group hover:-translate-y-1.5"
              >
                <div>
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#1a73e8] to-[#1557b0] text-white font-medium flex items-center justify-center text-[18px] shadow-[0_4px_16px_rgba(26,115,232,0.5)] group-hover:scale-110 transition-transform">
                      {ele.number}
                    </div>
                    <h3 className="text-[19px] font-medium text-white m-0 leading-tight">{ele.name}</h3>
                  </div>
                  <p className="text-[14.5px] text-white/70 leading-relaxed m-0 font-light">{ele.pera}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What We Do Section */}
      <section className="py-20 lg:py-28 bg-white border-b border-[#f1f3f4]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16 max-w-3xl mx-auto">
            <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-sm mb-3 block">Services Portfolio</span>
            <h2 className="text-3xl lg:text-[40px] font-medium text-[#202124] tracking-tight mb-4">What We Do</h2>
            <p className="text-[17px] text-[#5f6368] leading-relaxed">
              Oktobiz offers a comprehensive suite of professional solutions tailored to support your business journey from inception to continuous expansion.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {offers.map((ele) => (
              <div 
                key={ele.id} 
                className="bg-[#f8f9fa] rounded-[12px] p-8 border border-[#f1f3f4] hover:shadow-[0_4px_16px_rgba(0,0,0,0.05)] hover:border-[#dadce0] transition-all duration-300 flex flex-col justify-between"
              >
                <div>
                  <div className="w-9 h-9 rounded-full bg-[#e8f0fe] flex items-center justify-center text-[#1a73e8] mb-5">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  </div>
                  <h3 className="text-[19px] font-semibold text-[#202124] mb-3">
                    {ele.heading.replace(" :", "")}
                  </h3>
                  <p className="text-[15px] text-[#5f6368] leading-relaxed">
                    {ele.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Join Us / CTA Section */}
      <section className="py-20 lg:py-24 bg-[#f8f9fa]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-3xl mx-auto bg-white p-8 sm:p-12 lg:p-16 rounded-[20px] border border-[#dadce0] shadow-sm text-center flex flex-col items-center">
            <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-xs mb-3 block">Start Your Journey</span>
            <h2 className="text-3xl sm:text-4xl font-medium text-[#202124] tracking-tight mb-4">
              Join us in amplifying your business success
            </h2>
            <p className="text-[16px] text-[#5f6368] mb-10 max-w-xl leading-relaxed">
              Whether you are starting your first enterprise or scaling an existing operation, Oktobiz provides the expert framework to get you there safely.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <Link 
                to="/services/llc-formation" 
                className="bg-[#1a73e8] !text-white px-9 py-3.5 rounded-[4px] font-medium text-[15px] hover:!bg-[#1557b0] transition-colors shadow-md flex items-center justify-center !no-underline cursor-pointer"
              >
                Form an LLC
              </Link>
              <Link 
                to="/contact-us" 
                className="bg-white border-2 border-[#1a73e8] !text-[#1a73e8] px-9 py-3.5 rounded-[4px] font-medium text-[15px] hover:!bg-[#1a73e8] hover:!text-white transition-colors flex items-center justify-center !no-underline cursor-pointer"
              >
                Contact Our Team
              </Link>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
